import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChannelsVideos } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToVideos } from '../hooks';

const PageChannelsVideos = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToVideos = useNavigateToVideos();

  return (
    <AppLayout>
      <ChannelsVideos
        getPathToVideoDetail={(id) => getPathToEntityDetail(id, { entityType: 'video' })}
        navigateToVideos={navigateToVideos}
        organizationId={organizationId}
      />
    </AppLayout>
  );
};

export default PageChannelsVideos;
